import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ContraEntryForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    entry_date: "",
    description: "",
  });
  
  const [lines, setLines] = useState([
    { account: "", amount: "", side: "Dr" },
    { account: "", amount: "", side: "Cr" }
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleLineChange = (index, field, value) => {
    const newLines = [...lines];
    newLines[index][field] = value;
    setLines(newLines);
  };

  const addLine = () => {
    setLines([...lines, { account: "", amount: "", side: "Dr" }]);
  };

  const removeLine = (index) => {
    setLines(lines.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        entry_date: formData.entry_date,
        description: formData.description,
        entry_type: "Contra",
        lines: lines.map(l => ({ ...l, amount: parseFloat(l.amount) }))
      };
      await axios.post("/api/journal/", payload);
      navigate("/dashboard/transactions/contra/list");
    } catch (err) {
      console.error(err);
      alert("Error submitting form: " + (err.response?.data?.detail || err.message));
    }
  };

  return (
    <div style={{ maxWidth: "800px", margin: "auto", padding: "20px" }}>
      <h2>Add Contra Entry</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "10px" }}>
          <label>Date:</label>
          <input
            type="date"
            name="entry_date"
            value={formData.entry_date}
            onChange={handleChange}
            required
            style={{ width: "100%", padding: "8px" }}
          />
        </div>
        <div style={{ marginBottom: "10px" }}>
          <label>Description:</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
            style={{ width: "100%", height: "60px", padding: "8px" }}
          />
        </div>
        
        <h4>Lines</h4>
        {lines.map((line, index) => (
          <div key={index} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
            <select 
              value={line.side} 
              onChange={(e) => handleLineChange(index, "side", e.target.value)}
              style={{ padding: "8px" }}
            >
              <option value="Dr">Debit (Dr)</option>
              <option value="Cr">Credit (Cr)</option>
            </select>
            <input
              type="text"
              placeholder="Account"
              value={line.account}
              onChange={(e) => handleLineChange(index, "account", e.target.value)}
              required
              style={{ flex: 1, padding: "8px" }}
            />
            <input
              type="number"
              placeholder="Amount"
              value={line.amount}
              onChange={(e) => handleLineChange(index, "amount", e.target.value)}
              required
              step="0.01"
              min="0.01"
              style={{ flex: 1, padding: "8px" }}
            />
            {lines.length > 2 && (
              <button type="button" onClick={() => removeLine(index)} style={{ padding: "8px", background: "red", color: "white", border: "none" }}>X</button>
            )}
          </div>
        ))}
        
        <button type="button" onClick={addLine} style={{ padding: "8px 16px", marginBottom: "20px", cursor: "pointer" }}>
          + Add Line
        </button>
        <br />
        <button type="submit" style={{ padding: "10px 20px", background: "#0077cc", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer" }}>
          Save Contra Entry
        </button>
      </form>
    </div>
  );
};

export default ContraEntryForm;
